module.exports = __webpack_public_path__ + "img/DRIVE_CAR.be6af89d.svg";